// @flow
import * as React from 'react';
import _ from 'lodash';

import styled from 'styled-components';
import { Field } from 'redux-form';
import colors from '../../../assets/css/colors';

import { Label, FormGroup, Tooltip } from '../../Form';

import Lock from '../../../components/Icons/Lock';
import { BorderedIcon } from "../../../components";
import { below } from "../../../assets/css/media";

const RadioSwitch = styled.div`
	display: flex;
	height: 36px;
	align-items: center;
	border-radius: .4em;
	width: 100%;
	opacity: ${({ is_disabled }) => is_disabled ? '.5' : '1'};
	margin: 0.6em 0 0;
	margin-left: ${({ is_disabled }) => is_disabled ? '1em' : '0'};

	input {
		display: none;

		&:checked + label {
			background: ${colors.nrlGreen};
			border-color: ${colors.nrlGreen};
		}

		&:disabled + label {
			opacity: .5;
		}
	}

	${below.desktop`
		height: 30px;
	`}

	label {
		display: flex;
		justify-content: center;
		text-transform: uppercase;
		line-height: 1.7;
		padding: .7em 2em;
		margin: 0;
		font-size: 12px;
		font-weight: bold;
		font-weight: normal;
		cursor: pointer;
		opacity: ${({ is_disabled }) => is_disabled ? '.5' : '1'};
		font-weight: bold;

		flex-basis: 50%;
		border: 1px solid ${colors.form_border};

		&:nth-of-type(2) {
			border-right: none;
			border-left: none;
		}

		&:first-of-type {
			border-radius: .4em 0 0 .4em;
			border-right: none;
		}

		&:last-child {
			border-radius: 0 .4em .4em 0;
			border-left: none;
			border-right: 1px solid #D8D8D8;
		}

		${below.desktop`
			padding: 1em;
			line-height: 1.5;
		`}
	}
`;

type Props = {
	label: string,
	name: string,
	is_disabled: boolean,
	tooltip: {
		title: string,
		description: string,
	},
	elements: Array<Object>,
	is_string_value?: boolean,
};

export const FormRadio = ({
	label,
	name,
	elements,
	tooltip,
	is_disabled,
	is_string_value,
}: Props) => (
	<div>
		<Label>
			{label}
		</Label>
		<FormGroup>
			{is_disabled ? (
				<BorderedIcon padding='.25em'>
					<Lock size="2" />
				</BorderedIcon>
			) : ''}
			<RadioSwitch is_disabled={is_disabled}>
				{
					_.map(elements, ({ value, text }, index) => {
						return [
							<Field
								parse={value => (is_string_value ? value : _.toInteger(value))}
								name={name}
								id={`${name}_${value}`}
								value={value}
								component='input'
								type='radio'
								key={index}
								disabled={is_disabled}
							/>,
							<label
								htmlFor={`${name}_${value}`}
								key={index + 1}
							>
								{text}
							</label>
						];
					})
				}
			</RadioSwitch>
			<Tooltip {...tooltip} />
		</FormGroup>
	</div>
);

export default FormRadio;


// WEBPACK FOOTER //
// ./src/components/Form/FormRadio/index.js